<div class="-p-1.5 flex flex-col">
  @for (item of items(); track $index) {
    @let text = item.text | language;
    <div class="flex flex-row items-start py-1.5">
      <div
        class="relative mt-0.5 h-2.5 w-2.5 shrink-0 rounded-3xl p-2.5"
        [ngStyle]="{
          backgroundColor: corporateDesignService.isDarkModeActive()
            ? corporateDesignService.corporateDesign().colorAdmixtures.dark_text
            : corporateDesignService.corporateDesign().primaryColor,
        }"
        [attr.data-testid]="id() | appendTestId: 'icon'">
        <div
          class="absolute top-0 left-0 flex h-full w-full flex-row items-center justify-center">
          <div class="flex flex-row items-center justify-center text-white">
            <span class="material-symbols-rounded text-sm!">
              {{ item.icon || 'check' }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="min-w-0 flex-1 pl-3 text-base [overflow-wrap:anywhere] [hyphens:auto]"
        [attr.lang]="languageService.activeLanguage().prefix.toLowerCase()"
        [attr.data-testid]="id() | appendTestId: 'text'"
        [attr.aria-label]="item.text"
        [ngStyle]="{
          color: corporateDesignService.isDarkModeActive()
            ? corporateDesignService.corporateDesign().colorAdmixtures.dark_text
            : '',
        }">
        @if (item.link) {
          <a
            class="underline"
            [ngStyle]="{
              color: corporateDesignService.primaryColor(),
            }"
            [href]="item.link">
            @if (isQuillText(text)) {
              <ng-container
                *ngTemplateOutlet="richText; context: { $implicit: text }" />
            } @else {
              {{ text }}
            }
          </a>
        } @else {
          @if (isQuillText(text)) {
            <ng-container
              *ngTemplateOutlet="richText; context: { $implicit: text }" />
          } @else {
            {{ text }}
          }
        }
      </div>
    </div>
  }
</div>

<ng-template #richText let-text>
  <span class="whitespace-pre-wrap">
    @for (operation of getQuillOperations(text); track $index) {
      <span
        [class.font-bold]="operation.attributes?.bold"
        [class.italic]="operation.attributes?.italic"
        [class.underline]="operation.attributes?.underline"
        [class.line-through]="operation.attributes?.strike"
        [style.color]="operation.attributes?.color ?? null"
        [style.background-color]="operation.attributes?.background ?? null"
        [style.font-size]="getFontSize(operation.attributes?.size)"
        >{{ getOperationText(operation) }}</span
      >
    }
  </span>
</ng-template>
